import { CircularProgress } from "@mui/material";
import { RouterProvider } from "react-router-dom";
import "./App.css";
import { useAppSelector } from "./app/hooks";
import useAuth from "./app/useAuth";
import { authRouter, unAuthRouter } from "./route/route";

export default function App() {
  const { isLoggedIn, l } = useAuth();

  const { loading } = useAppSelector((s) => s.auth);
  if (loading || l) return <CircularProgress />;
  if (isLoggedIn) return <RouterProvider router={authRouter} />;
  return <RouterProvider router={unAuthRouter} />;
}
